<template>
    <div>
        <ScenarioResult />
        <Summary />
    </div>
</template>

<script>
import ScenarioResult from '../ScenarioResult.vue';
import Summary from '../../Summary/index.vue';

export default {
    components: { ScenarioResult, Summary },
}

</script>

<style></style>
